import React, {useState} from 'react';
import {  Button} from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { Alert } from 'react-bootstrap';

function GestionTournoi(props) {
    const [error, setError] = useState(false);
    const [confirmation,setConfirmation] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState()
    const apiUrl = process.env.REACT_APP_API_URL;



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setConfirmation(false);
        
        try {
          await axios.patch(`${apiUrl}/tournois/status/modifier`, {
            status : status,
            idTournois : props.item.id_tournoi
          }, {
            withCredentials: true
          });
    
          setError(null);
          setStatus()
          setIsLoading(false);
          window.location.reload(); 
  
        } catch (error) {
          setStatus()
          if (error.response) {
            setIsLoading(false)
            setError(error.response.data.message);
          } else {
            setIsLoading(false)
            setError(true);
          }
        }
      };


      if (isLoading) {
        return (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
        
        );  
      }

  return (
    <>
    {error && <Alert variant="danger">{error}</Alert>}
    {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => {setConfirmation(false);setStatus()}}>
                <Modal.Header closeButton>
                  <Modal.Title>{status === 'confirmer' ? ("Confirmer l'organisation du tournoi"):('Annuler le tournoi')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Voulez-vous vraiment confirmer votre choix ?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => {setConfirmation(false);setStatus()}} >
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Confirmer
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
    {props.item && (
            <div style={{textAlign:"right"}}>
                {props.item.status === 'en attente' &&(
                    <>
                        <Button variant="secondary" onClick={() => {setConfirmation(true);setStatus('annuler')}}>
                                Annuler le tournoi
                        </Button>
                        &nbsp;
                        <Button variant="primary" style={{backgroundColor:"#00E676", borderColor:'#00E676'}} onClick={() => {setConfirmation(true);setStatus('confirmer')}}>
                            Confirmer le tournoi
                        </Button>
                    </>
                ) }
                {props.item.status === 'confirmer' &&(
                    <>
                        <Button variant="secondary" onClick={() => {setConfirmation(true);setStatus('annuler')}}>
                                Annuler le tournoi
                        </Button>
                    </>
                ) }
                {props.item.status === 'annuler' &&(
                    <>
                        <Button variant="primary" style={{backgroundColor:"#00E676", borderColor:'#00E676'}} onClick={() => {setConfirmation(true);setStatus('confirmer')}}>
                            Confirmer le tournoi
                        </Button>
                    </>
                ) }
             </div>
            )}

    </>
  );
}

export default GestionTournoi;